export { createDOM } from './create-dom';
export { modifyCSS } from './modify-css';
//# sourceMappingURL=index.js.map